import { Component } from '@angular/core';

@Component({
    selector: 'app-pagenot-found',
    imports: [],
    template: `
  <div class="Pagenotfound">
  <p>Page not found </p>
  </div>
  `
})
export class PagenotFoundComponent {

}
